
import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { Observable } from 'rxjs';
import { JobsRepository } from "../../repositories";
import { CalculatePlanJobETARequest } from "../../domain/requests/jobs/calaculate-plan-job-eta-request";

@Injectable({ providedIn: 'root' })
export class CalculateHDPlanJobETAUsecase implements UseCase<CalculatePlanJobETARequest, boolean> {

  constructor(private readonly jobsRepository: JobsRepository) {
  }

  execute(params: CalculatePlanJobETARequest): Observable<boolean> {
    return this.jobsRepository.CalculateHDPlanJobETA(params);
  }

}
